import * as msal from "@azure/msal-browser";

let msalInstance;
export let msalPluginInstance;

export class MsalPlugin {
  pluginOptions = {
    clientId: "",
    authority: "",
  };

  isAuthenticated = false;

  install(app, options) {
    if (!options) {
      throw new Error("MsalPluginOptions must be specified");
    }
    this.pluginOptions = options;
    this.initialize(options);
    msalPluginInstance = this;
    app.config.globalProperties.$msal = msalPluginInstance;

    app.provide("$msal", msalPluginInstance);
  }

  initialize(options) {
    const msalConfig = {
      auth: {
        clientId: options.clientId,
        authority: options.authority,
      },
      cache: {
        cacheLocation: msal.BrowserCacheLocation.LocalStorage,
      },
      system: {
        loggerOptions: {
          loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
              return;
            }
            switch (level) {
              case msal.LogLevel.Error:
                console.error(message);
                return;
              case msal.LogLevel.Info:
                console.info(message);
                return;
              case msal.LogLevel.Verbose:
                console.debug(message);
                return;
              case msal.LogLevel.Warning:
                console.warn(message);
                return;
            }
          },
          piiLoggingEnabled: false,
          logLevel: msal.LogLevel.Verbose,
        },
      },
    };
    msalInstance = new msal.PublicClientApplication(msalConfig);
    this.isAuthenticated = this.getIsAuthenticated();
  }

  async signIn() {
    try {
      const loginRequest = {
        scopes: [
          "User.Read",
          "api://ddd9df78-61a9-4c95-84ba-b4f11eadea38/user_impersonation",
        ],
      };
      const loginResponse = await msalInstance.loginPopup(loginRequest);
      this.isAuthenticated = !!loginResponse.account;

      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        loginResponse.account = accounts[0];
        msalInstance.setActiveAccount(loginResponse.account);
      }
      await msalInstance.handleRedirectPromise();
    } catch (err) {
      // handle error
      if (err.errorMessage && err.errorMessage.indexOf("AADB2C90118") > -1) {
        try {
          const passwordResetResponse = await msalInstance.loginPopup({
            scopes: [
              "openid",
              "profile",
              "offline_access",
              "<The scope for your API>",
            ],
            authority: this.pluginOptions.passwordAuthority,
          });
          this.isAuthenticated = !!passwordResetResponse.account;
        } catch (passwordResetError) {
          console.error(passwordResetError);
        }
      } else {
        this.isAuthenticated = false;
      }
    }
  }

  async signOut() {
    try {
      msalInstance.logout();
      this.isAuthenticated = false;
      console.log("Sign-out successful");
    } catch (error) {
      console.error("Sign-out failed", error);
      this.isAuthenticated = true;
    }
  }

  async acquireToken() {
    const request = {
      account: msalInstance.getAllAccounts()[0],
      scopes: ["api://ddd9df78-61a9-4c95-84ba-b4f11eadea38/user_impersonation"],
    };
    try {
      const response = await msalInstance.acquireTokenSilent(request);
      return response.accessToken;
    } catch (error) {
      if (error instanceof msal.InteractionRequiredAuthError) {
        return msalInstance.acquireTokenPopup(request).catch((popupError) => {
          console.error(popupError);
        });
      }
      alert("Your session has expired. Please sign in again.");
    }
  }

  getActiveAccount() {
    return msalInstance.getActiveAccount();
  }

  getIsAuthenticated() {
    const accounts = msalInstance.getAllAccounts();
    return accounts && accounts.length > 0;
  }
}
